// Copyright (c) 2016 Deere & Company

import ClaimQuestions from '../state/claim-questions';
import actions from '../../../action-list';
import {getDefaultState} from '../state';

const updateQuestionsRequiredOptions = (state, action) =>
    ClaimQuestions.update(state, {
        $set: action.data
    });

export default (state = getDefaultState().questionsRequiredOptions, action) => {

    const actionTypes = {
        [actions.UPDATE_CLAIM_MCC_FOLLOWUP_QUESTIONS_REQUIRED_OPTIONS]: updateQuestionsRequiredOptions
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/claim/marketing/mass-channel-customer-followup/reducers/questions-required-options.js